import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  TextFieldProps,
  InputLabel
} from '@mui/material';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import pallet from '../../layouts/pallet';
import { fontSizes } from '../../layouts/fontSizes';

export type TextInputWithIconProps = TextFieldProps & {
  field?: ControllerRenderProps<FieldValues, string>;
  label?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  hasTopLabel?: boolean;
  required?: boolean;
  rest?: TextFieldProps;
};

const TextInputWithIcon: React.FC<TextInputWithIconProps> = ({
  field,
  label,
  startIcon,
  endIcon,
  id,
  name,
  variant,
  hasTopLabel = true,
  required,
  ...rest
}) => {
  const inputId = id || name;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // Allow sizing (e.g., flex) to be applied to the container
        ...(rest?.sx as any)
      }}
    >
      {hasTopLabel && (
        <InputLabel
          required={required}
          sx={{
            mb: '6px',
            color: pallet.textLabel,
            fontSize: `${fontSizes.placeHolder} !important`,
            fontWeight: 600
          }}
        >
          {label}
        </InputLabel>
      )}
      <TextField
        {...field}
        {...rest}
        id={inputId}
        variant={'outlined'}
        fullWidth
        InputProps={{
          startAdornment: startIcon ? (
            <InputAdornment position='start' sx={{ padding: 0 }}>
              {startIcon}
            </InputAdornment>
          ) : undefined,
          endAdornment: endIcon ? (
            <InputAdornment position='end' sx={{ padding: 0 }}>
              {endIcon}
            </InputAdornment>
          ) : undefined
        }}
        sx={{
          '& input[type="date"]::-webkit-calendar-picker-indicator': {
            display: 'none'
          },
          '& input[type="date"]::-webkit-outer-spin-button': {
            display: 'none'
          },
          '& input[type="date"]::-webkit-inner-spin-button': {
            display: 'none'
          },
          // Keep input-level styles working too
          ...(rest?.sx as any)
        }}
      />
    </Box>
  );
};

export default TextInputWithIcon;
